module.exports = {"211302001":"南塔街道","211302002":"北塔街道","211302003":"前进街道","211302004":"凌河街道","211302005":"光明街道","211302006":"凌凤街道","211302007":"龙山街道","211302008":"站南街道","211302009":"红旗街道","211302010":"燕北街道","211302011":"燕都街道","211302100":"桃花吐镇","211302101":"他拉皋镇","211302102":"孙家湾镇","211302205":"长宝营子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211302.json
// module id = 590
// module chunks = 0